import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardFooter } from "reactstrap";
import SectionHeader from "@dhn/components/molecules/section-header";

/**
 * Card con SectionHeader opcional. Reemplaza el patrón repetido
 * Card > CardBody > SectionHeader de pantallas, tabs y modales.
 *
 * <SectionCard icon="fa-id-badge" title="Perfil" footer={<SaveButton />}>...</SectionCard>
 */
export default function SectionCard({
  actions,
  bodyClassName,
  children,
  className,
  compact,
  description,
  footer,
  icon,
  title,
  variant,
}) {
  return (
    <Card className={className}>
      <CardBody className={bodyClassName}>
        {title && (
          <SectionHeader
            actions={actions}
            compact={compact}
            description={description}
            icon={icon}
            title={title}
            variant={variant}
          />
        )}
        {children}
      </CardBody>
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  );
}

SectionCard.propTypes = {
  actions: PropTypes.node,
  bodyClassName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  compact: PropTypes.bool,
  description: PropTypes.node,
  footer: PropTypes.node,
  icon: PropTypes.string,
  title: PropTypes.node,
  variant: PropTypes.oneOf(["primary", "secondary", "danger"]),
};

SectionCard.defaultProps = {
  compact: false,
  icon: "fa-folder-open-o",
  variant: "primary",
};
